import { render, staticRenderFns } from "./VideoResourceList.vue?vue&type=template&id=4d08bfd2&scoped=true"
import script from "./VideoResourceList.vue?vue&type=script&lang=js"
export * from "./VideoResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08bfd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d08bfd2')) {
      api.createRecord('4d08bfd2', component.options)
    } else {
      api.reload('4d08bfd2', component.options)
    }
    module.hot.accept("./VideoResourceList.vue?vue&type=template&id=4d08bfd2&scoped=true", function () {
      api.rerender('4d08bfd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/VideoResourceList.vue"
export default component.exports